export class Dict{

    id:number=null;
    dict_email_id:number= null;
    label:string=null;
    description:string=null;
    status:string=null;
    created_at:string=null;
    type:string=null;
    noConsultationDuTeleservice:string=null;
    noAffaireDuResponsableDuProjet:string=null;
    nomDuSignataire:string=null;
    files: any[]=[];
    city: string = null;

    constructor(id?: number | Object) {
        if (typeof (id) == 'object') {
            this.import(id);
        } else {
            this.id = id;
        }
    }

    import(data) {
        for (var key in data) {
            if (this.hasOwnProperty(key)) {
                this[key] = data[key];
            }
        }
    }
}